import React, { useState } from 'react'
import { Box } from '@mui/joy'
import { IconButton } from '../../assets'
import { Text } from '../Typography'
import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid'
import { RecipeSelector } from '.'

const ListToolbar = ({ isFullScreen, isImprenditoreVero, leftButtons = [], rightButtons = [], toggleFullscreen, dataProviderName, handleApplyRecipe, total, totalLabel }) => {

    const [settingsOpened, setSettingsOpened] = useState(false)

    const handleSettingsToggle = () => {
        setSettingsOpened(!settingsOpened)
    }

    return (
        <GridToolbarContainer className="list-toolbar" sx={{ justifyContent: 'space-between' }}>
            <Box className="list-toolbar-secondary list-toolbar-filter">
                {total !== undefined ? (
                    <Text level="body-sm">
                        {totalLabel} <span style={{ color: '#1976d2' }}>{total}</span>
                    </Text>
                ) : (
                    <>
                        {!isImprenditoreVero && <GridToolbarQuickFilter placeholder="Search..." sx={{ marginLeft: "auto" }} />}
                        {leftButtons.map((v, k) => <Box key={k}>{v}</Box>)}
                    </>
                )}
            </Box>
            {total === undefined && (
                <Box className="list-toolbar-primary" sx={{ display: "flex", gap: "5px" }}>
                    {settingsOpened ? (
                        <GridToolbarContainer>
                            <GridToolbarColumnsButton />
                            <GridToolbarFilterButton />
                        </GridToolbarContainer>
                    ) : (
                        rightButtons.map((v, k) => <Box key={k}>{v}</Box>)
                    )}
                    <IconButton onClick={handleSettingsToggle} className="list-toolbar-activator" icon="faEllipsisVertical" />
                    <IconButton icon={isFullScreen ? 'faMinimize' : 'faMaximize'} onClick={() => toggleFullscreen()} />
                </Box>
            )}
        </GridToolbarContainer>
    );
}

export default ListToolbar
